let openDropdown = null;

// Function to show/hide the dropdown and toggle the icon class
function toggleDropdown(dropdown) {
    if (openDropdown && openDropdown[0] !== dropdown[0]) {
        let openDropdownMenu = openDropdown.find('.dropdown-menu');
        openDropdownMenu.removeClass('show');
        openDropdown.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        openDropdown.attr('aria-expanded', 'false');
    }

    let dropdownMenu = dropdown.find('.dropdown-menu');
    let isExpanded = dropdownMenu.hasClass('show');

    dropdownMenu.toggleClass('show', !isExpanded);
    dropdown.find('i').toggleClass('fa-angle-down', isExpanded).toggleClass('fa-angle-up', !isExpanded);

    // Update aria-expanded attribute
    dropdown.attr('aria-expanded', !isExpanded);
    openDropdown = isExpanded ? null : dropdown;
}

// Show the dropdown when the button of any dropdown is clicked
$('.dropdown-toggle').on('click', function (event) {
    event.stopPropagation(); // Prevent click propagation to document
    let dropdown = $(this).closest('.dropdown');
    toggleDropdown(dropdown);
});

// Hide the dropdown when anything else on the screen is clicked
$(document).on('click', function (event) {
    // Check if the click target is not a dropdown or its children
    if (!$(event.target).closest('.dropdown').length) {
        $('.dropdown-menu').removeClass('show');
        $('.dropdown i').removeClass('fa-angle-up').addClass('fa-angle-down');
        $('.dropdown-toggle').attr('aria-expanded', 'false');
        openDropdown = null;
    }
});

// Close the dropdown on selecting an option
$('.dropdown-item input[type="radio"], .dropdown-item input[type="checkbox"]').on('click', function () {
    let dropdown = $(this).closest('.dropdown');
    toggleDropdown(dropdown);
});

// Toggle between showing and hiding password in password input fields
let eyeIcons = $('.input-container i.password-toggle');

for (let i = 0; i < eyeIcons.length; i++) {
    eyeIcons[i].addEventListener('click', function () {
        let password = eyeIcons[i].previousElementSibling;
        if (eyeIcons[i].classList.contains('fa-eye')) {
            eyeIcons[i].classList.add('fa-eye-slash');
            eyeIcons[i].classList.remove('fa-eye');
            password.type = 'text';
            eyeIcons[i].classList.add('show');
            eyeIcons[i].classList.remove('hide');
        } else {
            eyeIcons[i].classList.remove('fa-eye-slash');
            eyeIcons[i].classList.add('fa-eye');
            password.type = 'password';
            eyeIcons[i].classList.add('hide');
            eyeIcons[i].classList.remove('show');
        }
    });
}

$(document).ready(function () {
    $('.cn-input-validate').on('input', validateInput);
});

function validateInput() {
    var emailRegex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const value = $(this).val().trim();
    const input = $(this);
    console.log('input', value, input);
    let error;
    if (input.hasClass('password')) {
        if (value.length < 6) {
            error = 'Password must be more than 6 characters.';
        } else if (!/[!@#$%^&*()_+.,;:]/.test(value)) {
            error = 'Password must contain a special character.';
        } else {
            error = '';
        }
    } else if (input.attr('type') == 'email') {
        if (!emailRegex.test(value)) {
            error = 'Not a valid email format.';
        } else {
            error = '';
        }
    } else {
        if (value.length < 1) {
            error = 'Value required.';
        } else {
            error = '';
        }
    }

    if (error.length > 1) {
        input.parent().addClass('input-container__error');
        input.next().addClass('fa-ban');
        input.parent().next().text(error);
        if (input.hasClass('password') && input.next().hasClass('password-toggle')) {
            input.next().removeClass('fa-eye-slash');
            input.next().removeClass('fa-eye');
            input.next().addClass('fa-solid');
            input.next().removeClass('fa-regular');
        }
    } else {
        input.parent().removeClass('input-container__error');
        input.next().removeClass('fa-ban');
        input.parent().next().text('');
        if (input.hasClass('password') && input.next().hasClass('password-toggle')) {
            if (input.next().hasClass('show')) {
                input.next().addClass('fa-eye-slash');
            } else {
                input.next().addClass('fa-eye');
            }
            input.next().removeClass('fa-solid');
            input.next().addClass('fa-regular');
        }
    }
}

$('.cn-input').on('focus', addClassDiv);
$('.cn-input').on('focusout', removeClassDiv);

function addClassDiv() {
    let div = $(this).closest('.input-container');
    div.addClass('focus');
}

function removeClassDiv() {
    let div = $(this).closest('.input-container');
    div.removeClass('focus');
}

// Function to update the button text f
function updateButtonText(dropdown) {
    let selectedOptions = [];

    dropdown.find('.dropdown-item input').each(function () {
        if ($(this).is(':checked')) {
            selectedOptions.push($(this).val());
        }
    });

    let buttonText = 'Select one';
    if (selectedOptions.length > 0) {
        buttonText = selectedOptions.join(', ');
    }
    dropdown.find('span').text(buttonText);
}

$('.dropdown-item input').on('change', function () {
    let dropdown = $(this).closest('.dropdown');
    updateButtonText(dropdown);
});
